//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Chip from '@components/atoms/chip/Chip';
import { ITrackableComponent } from '@utils/withTracking';

interface Labeled {
  label: string;
}

interface ChipSetProps<T extends Labeled> extends ITrackableComponent {
  onClick: (option: T) => void;
  options: T[];
}

export const ChipSet = <T extends Labeled>({
  onClick,
  options,
  trackingId,
}: ChipSetProps<T>) => {
  return (
    <Container>
      {options.map((option) => (
        <Chip
          functionalIcon='close'
          key={option.label}
          onClick={() => onClick(option)}
          size='small'
          text={option.label}
          trackingId={trackingId}
        />
      ))}
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => `
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacings[1]};
`,
);
